import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Results from './components/Results';
import AddFish from './components/AddFish';
import Login from './components/Login';
import Setup from './components/Setup';
import RegisterAngler from './components/RegisterAngler';
import WeighIn from './components/WeighIn';
import Prizes from './components/Prizes';
import ProtectedRoute from './components/ProtectedRoute';
import SharkList from './components/SharkList';
import AuditLog from './components/AuditLog';
import EditShark from './components/EditShark';
import AuthCallback from './components/AuthCallback';

const isPublicMode = process.env.REACT_APP_PUBLIC_MODE === 'true';

function App() {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        setIsFullscreen(false);
      }
    }
  };

  if (isPublicMode) {
    return (
      <Router>
        <div className={`App ${isFullscreen ? 'fullscreen' : ''}`}>
          <main>
            <Routes>
              <Route path="*" element={<Results isFullscreen={isFullscreen} toggleFullscreen={toggleFullscreen} />} />
            </Routes>
          </main>
        </div>
      </Router>
    );
  }

  return (
    <Router>
      <div className={`App ${isFullscreen ? 'fullscreen' : ''}`}>
        {!isFullscreen && <Header />}
        <main>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/results" element={<ProtectedRoute><Results isFullscreen={isFullscreen} toggleFullscreen={toggleFullscreen} /></ProtectedRoute>} />
            <Route path="/add-shark" element={<ProtectedRoute><AddFish /></ProtectedRoute>} />
            <Route path="/setup" element={<ProtectedRoute><Setup /></ProtectedRoute>} />
            <Route path="/register-angler" element={<ProtectedRoute><RegisterAngler /></ProtectedRoute>} />
            <Route path="/weigh-in" element={<ProtectedRoute><WeighIn isFullscreen={isFullscreen} toggleFullscreen={toggleFullscreen} /></ProtectedRoute>} />
            <Route path="/prizes" element={<ProtectedRoute><Prizes /></ProtectedRoute>} />
            <Route path="/shark-list" element={<ProtectedRoute><SharkList /></ProtectedRoute>} />
            <Route path="/audit-log" element={<ProtectedRoute><AuditLog /></ProtectedRoute>} />
            <Route path="/edit-shark" element={<ProtectedRoute><EditShark /></ProtectedRoute>} />
          </Routes>
        </main>
        {!isFullscreen && <Footer />}
      </div>
    </Router>
  );
}

export default App;
